import type {
  AnalyticsPageContext,
  AnalyticsProvider,
  AnalyticsTrackEvent,
} from '../types';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export class GoogleAnalyticsProvider implements AnalyticsProvider {
  constructor(private readonly trackingCode: string | null | undefined) {}

  page(ctx: AnalyticsPageContext): void {
    if (!this.trackingCode || typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: ctx.pagePath,
      page_location: ctx.pageLocation,
    });
  }

  track(_event: AnalyticsTrackEvent): void {
    // Money/conversion goals are sent via Yandex (frontend funnel + backend MP).
  }
}
